<template>
	<div class="personTit">
    	<div class="left">您好，欢迎您来到中国建筑 (中小企业)产业互联网平台</div>

    	<div class="right"><span class="personCount">{{personCount}}</span><span class="logoutBtn" @click="loginOut">退出</span></div>  
    </div>
</template>
<script>
import { loginOut } from "@/api/login/login";
import { getUserInfo } from "@/api/person/person";
import { MessageBox,Message } from 'element-ui'
export default {
	name: 'persontit',
	data(){
		return{
			personCount:""	
		}
	},
	mounted(){
		this.getAccountFun()
	},
	activated(){
		
	},
	computed:{

	},
	methods: {
		loginOut(){
			let that = this;
	      	loginOut().then(res => {
				// console.log(res)
				if(res.success){
					window.sessionStorage.removeItem('token')
					window.sessionStorage.removeItem('username')
					window.localStorage.removeItem('token');
              		window.localStorage.removeItem('username');

					Message({
			          message: res.message,
			          type: 'success'
			        })
			     
				    let url=window.location.protocol+'//'+window.location.hostname
				    location.href='https://www.ssoieop.com.cn/esc-sso/logout?service='+url
				}else{
					Message({
			          message: res.message,
			          type: 'error'
			        })
				}
	      	});
		},

		getAccountFun(){
			let that=this
			
	      	getUserInfo().then(res=>{
		        //console.log(res)
		        if (res.success) {
		          let username  = res.result.phone
		          let certificationStatus = res.result.certificationStatus
		          window.localStorage.setItem('username',username)
		          that.$store.commit('setUserStatus', certificationStatus);
		          this.personCount=username.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2")
		        }
	      	})
		}
   	}
}
</script>





// WEBPACK FOOTER //
// src/components/global/persontit/index.vue